import React from 'react';
import IconSvg from '../../../img/trip_planner/steps/step_3.svg';

interface Step3DestinationProps {
    numberOfAdults: number;
    numberOfChildren: number;
    onUpdateTravelers: (adults: number, children: number) => void;
}

const Step3Destination: React.FC<Step3DestinationProps> = ({
    numberOfAdults,
    numberOfChildren,
    onUpdateTravelers
}) => {
    const handleAdultsChange = (increment: boolean) => {
        const newValue = increment ? numberOfAdults + 1 : numberOfAdults - 1;
        if (newValue >= 1) { // Minimum 1 adult
            onUpdateTravelers(newValue, numberOfChildren);
        }
    };

    const handleChildrenChange = (increment: boolean) => {
        const newValue = increment ? numberOfChildren + 1 : numberOfChildren - 1;
        if (newValue >= 0) { // Minimum 0 children
            onUpdateTravelers(numberOfAdults, newValue);
        }
    };
    // Onboarding - No. of Travelers
    return (
        <div className="space-y-6">
            <div className="text-center mb-8">
                <div className="w-20-h mx-auto mb-4 relative">
                    <img
                        src={IconSvg}
                        alt="Where are you going?"
                        className="w-full h-full object-contain"
                    />
                    <div className="absolute inset-0" style={{ backgroundColor: 'var(--primary-color)', mixBlendMode: 'lighten' }} />
                </div>
                <h2 className="text-2xl font-semibold mb-2 syne-fm">How many travelers are accompanying you?</h2>
            </div>

            <div className="flex flex-col md:flex-row justify-center gap-4">
                <div className="flex items-center gap-4 border border-primary-color px-4 py-2 rounded-full justify-around">
                    <span className="text-gray-700">Adults</span>
                    <div className="flex items-center">
                        <button
                            onClick={() => handleAdultsChange(false)}
                            disabled={numberOfAdults <= 1}
                            className={`w-8 h-8 flex items-center justify-center ${numberOfAdults <= 1 ? 'text-gray-300 cursor-not-allowed' : 'text-gray-700'}`}
                        >
                            -
                        </button>
                        <span className="mx-4 min-w-[20px] text-center">{numberOfAdults}</span>
                        <button
                            onClick={() => handleAdultsChange(true)}
                            className="w-8 h-8 flex items-center justify-center text-gray-700"
                        >
                            +
                        </button>
                    </div>
                </div>
                <div className="flex items-center gap-4 border border-primary-color px-4 py-2 rounded-full justify-around">
                    <span className="text-gray-700">Children</span>
                    <div className="flex items-center">
                        <button
                            onClick={() => handleChildrenChange(false)}
                            disabled={numberOfChildren <= 0}
                            className={`w-8 h-8 flex items-center justify-center ${numberOfChildren <= 0 ? 'text-gray-300 cursor-not-allowed' : 'text-gray-700'}`}
                        >
                            -
                        </button>
                        <span className="mx-4 min-w-[20px] text-center">{numberOfChildren}</span>
                        <button
                            onClick={() => handleChildrenChange(true)}
                            className="w-8 h-8 flex items-center justify-center text-gray-700"
                        >
                            +
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Step3Destination;
